import Header from '../../../__Layout/Header';
import React , {useState} from "react";
import Loader from '../../../utils/Loader';
import Delete from "./Delete";
import Create from "./Create";
import Update from "./Update";
import { Link } from 'react-router-dom';
import { useGetAdminTeacherQuestionQuery } from "../../../Services/api";
import {pageUrl,pageSize} from "../../../utils/constants/constants";
export default function Index() {
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState("");
    const {
        data: getAdminTeacherQuestion,
        isLoading: isGetLoading,
      } = useGetAdminTeacherQuestionQuery({ pageUrl, params:  {search,page,pageSize}  });
       
      const getPrevious= () => {
        setPage(page-1);
        setSearch("");
      }
      const getNext=()=>{
        setPage(page+1);
        setSearch("");
      }
      const findSearch=(e)=>{
        setPage(0);
        setSearch(e.target.value);
      }
      const [taskId,setTaskId] = useState("");
      const formatDateDubai = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString('en-GB', {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: '2-digit',
            hour: 'numeric',
            minute: '2-digit',
            hour12: true,
            timeZone: 'Asia/Dubai'
        });
    };
   
      if(isGetLoading) return  <Loader></Loader>
      return (
        <div className="vehicleCategories">
            <Header />
            <main id="main" className="main">
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Manage Task Question</h5>
                    <ul className="nav nav-tabs nav-tabs-bordered d-flex" id="borderedTabJustified" role="tablist">
                       <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100 active" id="home-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-home" type="button" role="tab" aria-controls="home" aria-selected="true">Question List</button>
                        </li>
                        {/* <li className="nav-item flex-fill" role="presentation">
                        <button className="nav-link w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#bordered-justified-profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Question Add</button>
                        </li> */}
                        
                    </ul>
                    <div className="tab-content pt-2" id="borderedTabJustifiedContent">
                        <div className="tab-pane fade show active" id="bordered-justified-home" role="tabpanel" aria-labelledby="home-tab"> 
                            <section className="section">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <h5 className="card-title">Task List</h5>
                                                <div className='row'>
                                                    <div className='col-lg-8'></div>
                                                    <div className='col-lg-4'>
                                                        <div className="datatable-search pull-right">
                                                            <input className="datatable-input" placeholder="Search..." type="search" title="Search within table" onChange={findSearch}/>
                                                        </div>
                                                    </div>
                                                </div>
                                                <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>#</th>
                                                                <th className='text-capitalize'>Title</th>
                                                                <th className='text-capitalize'>Start Date</th>
                                                                <th className='text-capitalize'>End Date</th>
                                                                <th className='text-capitalize'>First Post Date</th>
                                                                <th className='text-capitalize'>Task </th>
                                                                <th className='text-capitalize'> Details</th>
                                                                <th className='text-capitalize'>action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {
                                                            getAdminTeacherQuestion?.data?.map((item, index) => {       
                                                            return (
                                                                <tr key={index}>
                                                                    <th scope="row">{index + 1}</th>
                                                                    <td>{item.title}</td>
                                                                    <td>{formatDateDubai(item.start_date)}</td>
                                                                    <td>{formatDateDubai(item.end_date)}</td>
                                                                    <td>{formatDateDubai(item.first_post_date)}</td>
                                                                    <td>{item?.course_task_detail?.title}</td>
                                                                    <td>{item.descriptions}</td>
                                                                     
                                                                    <td>
                                                                        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
                                                                            <div className="btn-group" role="group">
                                                                                <button id="btnGroupDrop1" type="button" className="btn btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                                Action
                                                                                </button>
                                                                                <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
                                                                                <Link to={`/teacher-questions/3/${item.course_task_id}`} className="dropdown-item"  >
                                                                                    <div className="icon text-info">
                                                                                    
                                                                                        View Discussion
                                                                                    </div>
                                                                                </Link>
                                                                                
                                                                            
                                                                                 {/* <button className="dropdown-item"  data-bs-toggle="modal" onClick={()=>setTaskId(item.id)} data-id={item.id} data-bs-target="#fullscreenModal" >
                                                                                    <div className="icon text-info">
                                                                                    <i className="bi bi-pencil-square"></i>
                                                                                        Update
                                                                                    </div>
                                                                                </button>
                                                                                
                                                                                <Delete id={item.task_id} /> */}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </td>                                                                    
                                                                </tr>                                            
                                                                )  
                                                            })  
                                                        } 
                                                        </tbody>
                                                </table>                        
                                                <nav aria-label="Page navigation example">
                                                    <ul className="pagination">
                                                    {getAdminTeacherQuestion?.data?.currentPage !==0 ? <li className="page-item"><button type="button" className="page-link" onClick={getPrevious}>Previous</button></li> :''}
                                                    <li className="page-item"> {getAdminTeacherQuestion?.data?.currentPage+1} </li>                                                  
                                                    <li className="page-item"> of {getAdminTeacherQuestion?.data?.totalPages}</li>
                                                    {getAdminTeacherQuestion?.data?.currentPage !==getAdminTeacherQuestion?.data?.totalPages ? <li className="page-item"><button type="button" className="page-link" onClick={getNext}>Next</button></li>:''}
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>  
                        </div>
                        <Update id={taskId}/>
                        <Create />
                        
                    </div>
                </div>
               
            </div>

            </main>
          
        </div>
    );
}
